export default [{
  value: 'pending',
  text: 'Pendiente'
}, {
  value: 'approved',
  text: 'Pagado'
}]



// WEBPACK FOOTER //
// ./src/data/paymentStatus.js